// extracted by mini-css-extract-plugin
export default {"content":"CreateUserForm_content__c4afj","header":"CreateUserForm_header__5qzsV","formWrap":"CreateUserForm_formWrap__9ySA+","btnWrap":"CreateUserForm_btnWrap__kUGLm"};